export default __webpack_public_path__ + "0569375ed4b244b3370debf7302e8ead.png";